import { DomainError } from '@dma/shared';

export class InvalidMineralError extends DomainError {
  constructor(reason: string) {
    super('INVALID_MINERAL', `Mineral is invalid: ${reason}`);
    this.name = 'InvalidMineralError';
    Object.setPrototypeOf(this, InvalidMineralError.prototype);
  }
}
